import Vue from 'vue'
import douNpmPracticeBreadcrumb from './breadcrumb'
import LayoutBody from "./layout-body";
import TopForm from "./top-form";
import Table from "./table";
import Pagination from "./pagination";
import Dialog from "./dialog";
import DialogForm from "./dialog-form";
import DialogEditTable from "./dialog-edit-table";
import DialogUploadVue from './upload';
import douNpmTreetable from '../Subassembly/TreeTable'
import { uploadVue, exportVue, exportTemplateVue } from '@/layout/Excel/index.js'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import vueBaiduMap from './baiduMap'
import DialogTable from "./dialog-table";

import onlineContact from './onlineContact'

// 注意 有些组件使用异步加载会有影响
Vue.component('tree-table', douNpmTreetable)
Vue.component('breadcrumb', douNpmPracticeBreadcrumb)
Vue.component('iyeed-layout-body', LayoutBody)
Vue.component('iyeed-top-form', TopForm)
Vue.component('iyeed-table', Table)
Vue.component('iyeed-pagination', Pagination)
Vue.component('iyeed-dialog', Dialog)
Vue.component('iyeed-dialog-form', DialogForm)
Vue.component('iyeed-dialog-edit-table', DialogEditTable)
Vue.component('iyeed-upload', uploadVue)
Vue.component('iyeed-dialog-upload', DialogUploadVue)
Vue.component('iyeed-export', exportVue)
Vue.component('iyeed-export-template', exportTemplateVue)
Vue.component('el-image-viewer', ElImageViewer)
Vue.component('vue-baidu-map', vueBaiduMap)
Vue.component('online-contact', onlineContact)
Vue.component('iyeed-dialog-table', DialogTable)



// WEBPACK FOOTER //
// ./src/components/index.js